import { PricesView } from "@/admin/prices/PricesView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/prices")({
    component: PricesView,
});
